import React from 'react'

const Footer = () => {
  return (
    <section className="w-full bg-gray-800 p-8">
      <div className='flex flex-col gap-1 items-center justify-center'>
        <p className='text-white '>Copyright&copy; E-commerce website 2023.All rights reserved</p>
        <h6 className='text-white text-sm'>made by <span className=''>ZAHRA ASGARI</span></h6>
      </div>
    </section>
  )
}

export default Footer